const AutodeskInventorCourse = {
    id: "autodesk-inventor",

    name: "Autodesk Inventor Automation & Customization API",
syllabusPdf: "/syllabus/Inventor-Syllabus.pdf",

    hero: {
        title: "Autodesk Inventor Automation & Customization API",
        subtitle: "Live & Interactive Online Training",
        logo: "/inventor-2.webp",

        points: [
            "Master Autodesk Inventor Automation using API programming with C# .NET. Automate part modeling, assembly generation, and drawing creation for high-efficiency design workflows.",

            "Perfect for mechanical engineers and CAD professionals aiming to move into high-paying roles with advanced Inventor customization and design automation skills.",

            "Transform your career from traditional CAD work to next-level automation, leveraging the power of the Inventor API with C# to build intelligent, rule-driven CAD systems.",

            "Begin with zero programming experience — we start from the basics of computer programming and guide you step-by-step into professional-level API development.",

            "Learn directly from industry experts working on real-world automation projects in top manufacturing and product design companies — with complete career mentoring and portfolio support."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "“For Autodesk inventor Design Engineers with 4 to 5 years of experience, the average CTC ranges from 5 Lakhs to 10 Lakhs. However, Autodesk inventor Developers with the same experience can command CTCs of 20 Lakhs to 30 Lakhs.”"
        },
        {
            title: "Good Demand",
            description:
                "“While Autodesk inventor Design is a well-known skill among mechanical engineers, there is intense competition for design jobs. On the other hand, Autodesk inventor Automation & Customization is a niche expertise, with only a few engineers.”"
        },
        {
            title: "Easier To Learn",
            description:
                "“While Autodesk inventor Design is generally easier to learn, Autodesk inventor Automation & Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training.”"
        }
    ],

    whyLearn: [
        {
            title: "Automate Repetitive CAD Tasks",
            description:
                "Reduce hours of manual modeling work by automating repetitive tasks like part generation, dimensioning, and drawing creation — saving time and increasing consistency."
        },
        {
            title: "Build Rule-Based Design Tools",
            description:
                "Create custom logic-driven applications that respond to user input or data — ideal for product configurators, mass customization, and parametric design automation."
        },
        {
            title: "Accelerate Product Development Cycles",
            description:
                "Speed up part, assembly, and drawing creation drastically, helping teams deliver faster to market and handle high-volume projects with ease."
        },
        {
            title: "Enhance Your Core CAD Skills",
            description:
                "Go beyond regular 3D modeling by understanding Inventor’s internal structure, object models, and how it can be controlled programmatically with C#."
        },
        {
            title: "Highly Valued by Employers",
            description:
                "Companies in automotive, aerospace, manufacturing, and industrial design actively look for engineers with Inventor API and C# skills — a rare and in-demand combo."
        },
        {
            title: "Develop Custom Plugins for Your Company or Clients",
            description:
                "Build tailored Inventor tools and add-ins that exactly match your organization’s workflow, giving you or your company a significant competitive edge."
        },
        {
            title: "Bridge Engineering and Software Development",
            description:
                "Gain software development experience while staying rooted in mechanical design — opening up roles like CAD Developer, Automation Engineer, or Design Technologist."
        },
        {
            title: "Integrate Inventor with Excel, ERP, or Databases",
            description:
                "With the Inventor API and C#, you can create tools that interact with spreadsheets, product databases, or PLM/ERP systems for intelligent data-driven design."
        },
        {
            title: "Start Freelance or Product-Based Services",
            description:
                "Inventor API skills allow you to offer freelance design automation services or build your own productivity plugins to sell to other engineers and companies."
        },
        {
            title: "Future-Proof Your Career in Design Automation",
            description:
                "As industries move toward digital twins, generative design, and intelligent manufacturing, automation skills in Inventor are essential to stay relevant and future – ready."
        }
    ],

syllabus: [
    {
        name: "C#.NET",
        modules: [
            {
                number: 1,
                title: "Environment Setup & Fundamentals",
                topics: [
                    "Environment Setup",
                    "Basic Syntax",
                    "Program Structure",
                    "Data Types",
                    "Variables",
                    "Constants",
                    "Modifiers",
                    "Statements",
                    "Operators",
                    "Using Math Functions"
                ]
            },
            {
                number: 2,
                title: "Control Flow",
                topics: [
                    "Decision Making (if, switch, etc.)",
                    "Loops (for, while, do-while, foreach)"
                ]
            },
            {
                number: 3,
                title: "Working with Data",
                topics: [
                    "Strings",
                    "Date & Time",
                    "Arrays (1D, 2D, and 3D)"
                ]
            },
            {
                number: 4,
                title: "Functions & Parameters",
                topics: [
                    "Defining Functions",
                    "Arguments & Return Types",
                    "in, out, and ref Parameters"
                ]
            },
            {
                number: 5,
                title: "Collections & Data Structures",
                topics: [
                    "List",
                    "ArrayList",
                    "Dictionary",
                    "Hashtable",
                    "Struct",
                    "Enum"
                ]
            },
            {
                number: 6,
                title: "Object-Oriented Programming",
                topics: [
                    "Classes & Objects",
                    "Constructor & Destructor",
                    "Access Modifiers (Public, Private, Protected, Internal)",
                    "Stack vs Heap Memory",
                    "Static Classes & Static Methods"
                ]
            },
            {
                number: 7,
                title: "Advanced OOP Concepts",
                topics: [
                    "Abstract Classes & Methods",
                    "Interfaces",
                    "Inheritance",
                    "Single Inheritance",
                    "Multiple Inheritance",
                    "Multilevel Inheritance",
                    "Polymorphism",
                    "Method Overloading",
                    "Method Overriding"
                ]
            },
            {
                number: 8,
                title: "Exception & File Handling",
                topics: [
                    "Exception Handling",
                    "Files & Directory Handling"
                ]
            },
            {
                number: 9,
                title: "Application Development",
                topics: [
                    "Creating Console Applications",
                    "Windows Forms Applications",
                    "Form Controls (TextBox, Button, Label, etc.)",
                    "Dialog Boxes",
                    "Advanced Forms",
                    "Event Handling"
                ]
            },
            {
                number: 10,
                title: "Libraries & Integration",
                topics: [
                    "Class Library & DLL Creation",
                    "Interacting with Notepad Files",
                    "Reading/Writing Excel Files"
                ]
            },
            {
                number: 11,
                title: "Visual Studio Essentials",
                topics: [
                    "Using Visual Studio Features",
                    "Build Events, Debugging, IntelliSense",
                    "Solution & Project Management"
                ]
            }
        ]
    },

    {
        name: "Inventor API",
        modules: [
            {
                number: 1,
                title: "Getting Started with Inventor API",
                topics: [
                    "Introduction to Inventor Customization",
                    "Configuring Visual Studio for Inventor API",
                    "Referencing and Linking Inventor Libraries",
                    "Debugging Inventor Applications within Visual Studio"
                ]
            },
            {
                number: 2,
                title: "File Operations",
                topics: [
                    "Programmatically Create, Open, and Save Inventor Files",
                    "Import & Export IGES and STEP Files",
                    "Export PDF and DWG Drawings",
                    "Batch Processing of Files and Drawings"
                ]
            },
            {
                number: 3,
                title: "User Interface Integration",
                topics: [
                    "Displaying Information via Custom UI",
                    "Creating User Interfaces for Add-ins and Plug-ins",
                    "Handling User Inputs for Sketches and Features"
                ]
            },
            {
                number: 4,
                title: "Geometry & Modeling Automation",
                topics: [
                    "Create Curves and Sketches Based on User Inputs",
                    "Create 3D Features (Extrude, Revolve, etc.) Programmatically",
                    "Read and Write Model Parameters",
                    "Looping Through Features for Automation",
                    "Edit Features Conditionally"
                ]
            },
            {
                number: 5,
                title: "Feature & Component Selection",
                topics: [
                    "Object Selection Techniques",
                    "Applying Selection Filters",
                    "Accessing and Editing Mass Properties",
                    "Working with Custom Attributes"
                ]
            },
            {
                number: 6,
                title: "Assembly Automation",
                topics: [
                    "Loop Through All Components in Assembly & Sub-Assembly",
                    "Show/Hide Components Based on Conditions",
                    "Use of Recursive Functions for Nested Assemblies",
                    "Edit Assembly Components Programmatically"
                ]
            },
            {
                number: 7,
                title: "Drawing Automation",
                topics: [
                    "Looping Through All Drawing Sheets and Views",
                    "Editing Drawing Sheets and Views Conditionally"
                ]
            },
            {
                number: 8,
                title: "Data Exchange & Integration",
                topics: [
                    "Read/Write Data from Excel",
                    "Connect External Data with Inventor Models"
                ]
            }
        ]
    }
],
    faq: [
        {
            question: "What is Autodesk Inventor?",
            answer:
                "Autodesk Inventor is a professional-grade 3D computer-aided design (CAD) software developed by Autodesk. It is used for designing and simulating mechanical and industrial parts, assemblies, and products. Autodesk Inventor offers a wide range of tools for parametric modeling, finite element analysis, rendering, and other design and engineering tasks, making it a versatile solution for product design and engineering."
        },
        {
            question: "How do CAA Developers command higher salaries?",
            answer:
                "CAA Developers often receive significantly higher salaries compared to CATIA 3D designers. This is because they create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.\n\nFor a detailed explanation, please view the video located at this page."
        },
        {
            question:
                "I have CAD design experience; will it be beneficial for me in CAD Automation & Customization?",
            answer:
                "Absolutely, having CAD design experience is an advantage. It allows you to fully leverage your design skills and familiarity with CAD tools.\n\nYou can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings.\n\nIn the future, your background can position you to lead teams of both design engineers and developers, bridging the gap between design excellence and cutting-edge automation solutions."
        },
        {
            question:
                "Can I work on all CAD Customization if I learn one?",
            answer:
                "Yes and No.\n\nIn the first part of the training, you’ll grasp programming concepts that are foundational for all CAD customizations, creating a strong common foundation.\n\nHowever, the CAD API knowledge gained in the second part of the training is tool-specific, tailored to a particular CAD software.\n\nTo work on various CAD customizations, you would need to familiarize yourself with the APIs specific to each tool. Yet, if you master one API thoroughly, you’ll find it relatively straightforward to adapt and learn others independently with minimal effort."
        },
        {
            question:
                "Why should I choose FeesWorth for learning CAD Automation and Customization?",
            answer:
                "When it comes to CAD Automation or Customization, FeesWorth is the most experienced institute, with over a decade of expertise in providing this training.\n\nWe have a unique ability to teach programming to Mechanical Engineers and CAD to software developers, making our training accessible to a diverse audience.\n\nOur success stories and proven track record demonstrate the effectiveness of our approach, ensuring you receive the best education in CAD Automation and Customization."
        },
        {
            question: "Is job guarantee provided with the courses?",
            answer:
                "No, job guarantee is not provided with this course, but job assistance is provided. This is because securing a job largely depends on your personal abilities and the effort you invest in practicing your CAD skills."
        },
        {
            question: "Which programming language is suitable for CAD Customization?",
            answer:
                "For CATIA CAA Customization and Creo Toolkit Customization, C++ is an excellent choice.\n\nFor other CAD tools such as NX, AutoCAD, Solidworks, Inventor, etc., C#.NET or VB.NET are well-suited programming languages."
        },
        {
            question: "What are the current job opportunities in this field?",
            answer:
                "This skill is quite rare, with a limited number of professionals available in the market compared to the growing demand. Consequently, the job opportunities in this field are in high demand and offer promising prospects."
        }
    ],

    videos: [
        {
            category: "CAD Customization & Automation",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=1\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-inventor-api-customization-automation-course%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-revit-api-customization-automation-course%2F\\&vf=1"
        },
        {
            category: "Real first Day programming class",
            title: "Day 1: Programming Class C#.NET",
            videoUrl:
                "https://www.youtube.com/embed/7U2z7LUMH9g?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=3\\&forigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-inventor-api-customization-automation-course%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2Fautodesk-revit-api-customization-automation-course%2F\\&vf=1"
        }
    ]
};

export default AutodeskInventorCourse;